import moment from "moment";
import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  handleSendFeedbackStart,
  handleSendFeedbackFailed,
  handleSendFeedbackSuccess,
} from "../redux/sendFeedback";
import { sendFeedbackApi } from "core/http/service/timeKeeping";
import {
  selectMonthYearListFeedback,
  selectMonthYearTimeCheckingData,
  sendFeedbackDataSelector,
} from "../redux/selector";
import { toast } from "react-toastify";
import { getListFeedbackStart } from "../redux/getListFeedback";
import { getTimeCheckingStart } from "../redux/getTimeKeeping";
import { SCREEN } from "helper/roleChecker/Screens";
import { ErrorMessage } from "core/http/service/decleareLeave/const";

function* handleSendFeedbackWork(action) {
  const timeSelected = yield select(selectMonthYearListFeedback);
  const { date, reason, type, id } = yield select(sendFeedbackDataSelector);
  const selectMonthYearTimeChecking = yield select(
    selectMonthYearTimeCheckingData
  );
  const screenCode = action.payload;

  try {
    yield call(
      sendFeedbackApi,
      { date: moment(date, "DD/MM/YYYY"), reason, type, id },
      screenCode
    );

    yield put({
      type: handleSendFeedbackSuccess.type,
    });
    toast.success("Phản hồi của bạn đã được gửi thành công");
    if (screenCode === SCREEN.IP_017) {
      const payload = {
        month: timeSelected.month,
        year: timeSelected.year,
        limit: 60,
        offset: 0,
        screenCode,
      };

      yield put({
        type: getListFeedbackStart.type,
        payload,
      });
    } else if (screenCode === SCREEN.IP_015) {
      const { year, month } = selectMonthYearTimeChecking;

      yield put({
        type: getTimeCheckingStart.type,
        payload: {
          id: `${year}-${month}`,
          month,
          year,
          screenCode: SCREEN.IP_015,
        },
      });
    }
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: handleSendFeedbackFailed.type,
    });
  }
}

function* watchHandleSendFeedback() {
  yield takeLatest(handleSendFeedbackStart.type, handleSendFeedbackWork);
}

export default function* handleSendFeedbackSaga() {
  yield all([watchHandleSendFeedback()]);
}
